import HTTPClient from './http-client';

const END_POINT = '/forecastdev/ows';

 // overwrite cache options
 const options = {
    cache: {
        maxAge: 24 * 60 * 60 * 1000,
        exclude: { query: false },
    }
}

const loadLocationsByTypeName = async (typeName) => {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const URL_SERVICE = `${END_POINT}?service=WFS&version=1.0.0&request=GetFeature&typeName=forecastdev:${typeName}&outputFormat=application%2Fjson`   

    return api.get(
        `${URL_SERVICE}`,
        options
    );
}

export {
  loadLocationsByTypeName,
}
